import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

// Users with the 'admin' or 'auditor' role can reach the admin shell. The
// sidebar and individual pages further restrict what each role sees and can
// do — auditors can only access the audit-log browser, for instance.
const ADMIN_SHELL_ROLES = ['admin', 'auditor'];

export default function AdminRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <div style={{ padding: 40, textAlign: 'center' }}>Loading…</div>;
  }
  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  if (!user.roles?.some(r => ADMIN_SHELL_ROLES.includes(r))) {
    return <Navigate to="/" replace />;
  }
  return children;
}
